module.exports = __webpack_public_path__ + "img/3.42d71c23.jpg";